<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section
      side
      class="relative-position"
      :top="top"
    >
      <profile-image
        :color="dark ? '#fff' : undefined"
        :size="dense ? 'sm' : undefined"
        :initials="client.initials || '#'"
        :profile-image="client.profile_image"
      />
    </q-item-section>
    <q-item-section>
      <q-item-label>
        <span
          class="module-name q-mr-xs"
        >
          {{ clientName }}
        </span>
        <slot
          v-if="hasTitleSlot"
          name="title"
        />
      </q-item-label>
      <q-item-label
        v-if="contactName"
        caption
        class="text-bold"
      >
        {{ contactName }}
      </q-item-label>
      <q-item-label
        v-if="!withoutEmail && clientEmail"
        caption
        :lines="1"
      >
        {{ clientEmail }}
      </q-item-label>
      <q-item-label
        v-if="!withoutAddress && clientAddress"
        caption
      >
        {{ clientAddress.full_address }}
        <small v-if="clientAddress.type !== 'PRIMARY'">
          ({{ clientAddress.field_name }})
        </small>
      </q-item-label>
      <slot
        v-if="hasContentSlot"
        name="content"
      />
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      :top="top"
      @click="onSideClick"
    >
      <slot />
    </q-item-section>
    <slot
      v-if="hasAfterSlot"
      name="after"
    />
  </q-item>
</template>

<script>
/*
  Partial to display client information on any page
*/
import clientDetails from 'components/app/clients/partials/mixins/clientDetails'
import itemMixin from 'src/helpers/item'

export default {
  mixins: [itemMixin, clientDetails],
  props: {
    client: {
      required: true,
      type: Object
    },
    top: {
      type: Boolean,
      default: false
    },
    preventSideClick: {
      type: Boolean,
      default: false
    },
    withoutEmail: {
      type: Boolean,
      default: false
    },
    withoutAddress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    hasContentSlot () {
      return !!this.$slots.content
    },
    hasAfterSlot () {
      return !!this.$slots.after
    },
    hasTitleSlot () {
      return !!this.$slots.title
    }
  },
  methods: {
    onSideClick (e) {
      if (this.preventSideClick) {
        e.stopPropagation()
      }
    }
  }
}
</script>
